// extracted by mini-css-extract-plugin
module.exports = {"Editor":"MonacoEditor_Editor__2aYSk","monaco-editor":"MonacoEditor_monaco-editor__3p3qR"};